import React from "react";
import { useTranslation } from "react-i18next";
import "./PricingTable.css";
import freemiumIcon from "../../../assets/landing-page/freemium-icon.svg";
import impactIcon from "../../../assets/landing-page/impact-icon.svg";
import togetherIcon from "../../../assets/landing-page/together-icon.svg";
import plusIcon from "../../../assets/landing-page/plus-icon.svg";
import catalystPlan from "../../../assets/landing-page/catalyst-plan.svg";
import ambitionPlan from "../../../assets/landing-page/ambition-plan.svg";
import togetherPlan from "../../../assets/landing-page/together-plan.svg";

const PricingTable = ({ openModal, isAbout }) => {
  const { t } = useTranslation();

  return (
    <div className="pricing-container">
      <h2 className="pricing-title">{t("CHOOSE_OPTION")}</h2>
      <div className="pricing-options">
        {/* Freemium Plan */}
        <div className="freemium-container">
          <div className="pricing-card freemium">
            <div className="card-header">
              <div className="plan-name-container">
                <h3 className="freemium-plan-name">{t("FREEMIUM")}</h3>
                <img
                  src={freemiumIcon}
                  alt="Freemium Icon"
                  width={78}
                  height={96}
                  className="pricing-floating-icon"
                />
              </div>

              <div className="plan-description">
                <p>{t("FREEMIUM_DESC")}</p>
              </div>

              <ul className="feature-list">
                <li>
                  <img
                    src={plusIcon}
                    width={18}
                    height={18}
                    alt="Plus Icon"
                    className="plus-icon-pricing"
                  />
                  {t("FREEMIUM_FEATURE_1")}
                </li>
                <li>
                  <img
                    src={plusIcon}
                    width={18}
                    height={18}
                    alt="Plus Icon"
                    className="plus-icon-pricing"
                  />
                  {t("FREEMIUM_FEATURE_2")}
                </li>
                <li>
                  <img
                    src={plusIcon}
                    width={18}
                    height={18}
                    alt="Plus Icon"
                    className="plus-icon-pricing"
                  />
                  {t("FREEMIUM_FEATURE_3")}
                </li>
                <li>
                  <img
                    src={plusIcon}
                    width={18}
                    height={18}
                    alt="Plus Icon"
                    className="plus-icon-pricing"
                  />
                  {t("FREEMIUM_FEATURE_4")}
                </li>
                <li>
                  <img
                    src={plusIcon}
                    width={18}
                    height={18}
                    alt="Plus Icon"
                    className="plus-icon-pricing"
                  />
                  {t("FREEMIUM_FEATURE_5")}
                </li>
              </ul>

              <div className="plan-icons">
                <div className="pricing-icon-container">
                  <div className="pricing-icon">
                    <img
                      src={freemiumIcon}
                      alt="Freemium Icon"
                      width={59}
                      height={69}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="price-container freemium-plan-name">
            <h3 className="price">{t("FREE_PRICE")}</h3>
          </div>
        </div>

        <div className="impact-container">
          {/* Catalyst Plan */}
          <div className="catalyst-container">
            <div className="coming-soon">{t("COMING_SOON")}</div>
            <div className="pricing-card impact">
              <div className="card-header">
                <div className="plan-name-container impact-plan">
                  <h3 className="plan-name">{t("CATALYST")}</h3>
                </div>

                <div className="plan-description">
                  <p>{t("CATALYST_DESC")}</p>
                </div>

                <ul className="feature-list">
                  <li>
                    <img
                      src={plusIcon}
                      width={18}
                      height={18}
                      alt="Plus Icon"
                      className="plus-icon-pricing"
                    />
                    {t("CATALYST_FEATURE_1")}
                  </li>
                  <li>
                    <img
                      src={plusIcon}
                      width={18}
                      height={18}
                      alt="Plus Icon"
                      className="plus-icon-pricing"
                    />
                    {t("CATALYST_FEATURE_2")}
                  </li>
                  <li>
                    <img
                      src={plusIcon}
                      width={18}
                      height={18}
                      alt="Plus Icon"
                      className="plus-icon-pricing"
                    />
                    {t("CATALYST_FEATURE_3")}
                  </li>
                  <li>
                    <img
                      src={plusIcon}
                      width={18}
                      height={18}
                      alt="Plus Icon"
                      className="plus-icon-pricing"
                    />
                    {t("CATALYST_FEATURE_4")}
                  </li>
                  <li>
                    <img
                      src={plusIcon}
                      width={18}
                      height={18}
                      alt="Plus Icon"
                      className="plus-icon-pricing"
                    />
                    {t("CATALYST_FEATURE_5")}
                  </li>
                </ul>

                <div className="plan-icons">
                  <div className="pricing-icon-container">
                    <div className="pricing-icon">
                      <img
                        src={catalystPlan}
                        alt="Catalyst Plan"
                        width={117}
                        height={71}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="price-container">
              <h3 className="price impact-price">{t("CATALYST_PRICE")}</h3>
              <div className="price-details">
                <p className="price-per">{t("PER_USER")}</p>
                <p className="annual-cost">{t("ANNUAL_COST_CATALYST")}</p>
              </div>
            </div>
          </div>
          <img
            src={impactIcon}
            alt="Impact Icon"
            width={78}
            height={96}
            className="pricing-floating-icon"
          />
          {/* Ambition Plan */}
          <div className="ambition-container">
            <div className="coming-soon">{t("COMING_SOON")}</div>
            <div className="pricing-card ambition-plan-container">
              <div className="card-header">
                <div className="plan-name-container">
                  <h3 className="plan-name">{t("AMBITION")}</h3>
                </div>

                <div className="plan-description">
                  <p>{t("AMBITION_DESC")}</p>
                </div>

                <ul className="feature-list">
                  <li>
                    <img
                      src={plusIcon}
                      width={18}
                      height={18}
                      alt="Plus Icon"
                      className="plus-icon-pricing"
                    />
                    {t("AMBITION_FEATURE_1")}
                  </li>
                  <li>
                    <img
                      src={plusIcon}
                      width={18}
                      height={18}
                      alt="Plus Icon"
                      className="plus-icon-pricing"
                    />
                    {t("AMBITION_FEATURE_2")}
                  </li>
                  <li>
                    <img
                      src={plusIcon}
                      width={18}
                      height={18}
                      alt="Plus Icon"
                      className="plus-icon-pricing"
                    />
                    {t("AMBITION_FEATURE_3")}
                  </li>
                  <li>
                    <img
                      src={plusIcon}
                      width={18}
                      height={18}
                      alt="Plus Icon"
                      className="plus-icon-pricing"
                    />
                    {t("AMBITION_FEATURE_4")}
                  </li>
                  <li>
                    <img
                      src={plusIcon}
                      width={18}
                      height={18}
                      alt="Plus Icon"
                      className="plus-icon-pricing"
                    />
                    {t("AMBITION_FEATURE_5")}
                  </li>
                </ul>

                <div className="plan-icons">
                  <div className="pricing-icon-container">
                    <div className="pricing-icon">
                      <img
                        src={ambitionPlan}
                        alt="Ambition Plan"
                        width={157}
                        height={72}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="price-container">
              <h3 className="price ambition-price impact-price">
                {t("AMBITION_PRICE")}
              </h3>
              <div className="price-details">
                <p className="price-per">{t("PER_USER")}</p>
                <p className="annual-cost">{t("ANNUAL_COST_AMBITION")}</p>
              </div>
            </div>
          </div>
        </div>

        {/* Better Together Plan */}
        <div className="together-container">
          <div className="coming-soon">{t("COMING_SOON")}</div>
          <div className="pricing-card together">
            <div className="card-header">
              <div className="plan-name-container">
                <h3 className="plan-name">{t("BETTER_TOGETHER")}</h3>
                <img
                  src={togetherIcon}
                  alt="Together Icon"
                  width={78}
                  height={96}
                  className="pricing-floating-icon"
                />
              </div>

              <div className="plan-description">
                <p>{t("TOGETHER_DESC")}</p>
              </div>

              <ul className="feature-list">
                <li>
                  <img
                    src={plusIcon}
                    width={18}
                    height={18}
                    alt="Plus Icon"
                    className="plus-icon-pricing"
                  />
                  {t("TOGETHER_FEATURE_1")}
                </li>
                <li>
                  <img
                    src={plusIcon}
                    width={18}
                    height={18}
                    alt="Plus Icon"
                    className="plus-icon-pricing"
                  />
                  {t("TOGETHER_FEATURE_2")}
                </li>
                <li>
                  <img
                    src={plusIcon}
                    width={18}
                    height={18}
                    alt="Plus Icon"
                    className="plus-icon-pricing"
                  />
                  {t("TOGETHER_FEATURE_3")}
                </li>
                <li>
                  <img
                    src={plusIcon}
                    width={18}
                    height={18}
                    alt="Plus Icon"
                    className="plus-icon-pricing"
                  />
                  {t("TOGETHER_FEATURE_4")}
                </li>
                <li>
                  <img
                    src={plusIcon}
                    width={18}
                    height={18}
                    alt="Plus Icon"
                    className="plus-icon-pricing"
                  />
                  {t("TOGETHER_FEATURE_5")}
                </li>
              </ul>

              <div className="plan-icons">
                <div className="pricing-icon-container">
                  <div className="pricing-icon">
                    <img
                      src={togetherPlan}
                      alt="Together Plan"
                      width={123}
                      height={74}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="price-container">
            <h3 className="price together-price">{t("TOGETHER_PRICE")}</h3>
            <div className="price-details">
              <p className="price-per">{t("PER_USER")}</p>
              <p className="annual-cost">{t("ANNUAL_COST_TOGETHER")}</p>
            </div>
          </div>
        </div>
      </div>

      {!isAbout && (
        <button className="get-started-btn" onClick={openModal}>
          {t("GET_STARTED")}
        </button>
      )}
    </div>
  );
};

export default PricingTable;
